import { useAtom } from '@reatom/npm-react'
import { t } from 'i18next'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { CreatorPairsTable } from '@root/features/services/creator-pairs/ui/creator-pairs-table/creator-pairs-table'
import { DevTokenStatistics } from '@root/features/services/dev-tokens/ui'
import { InfoMessageDt } from '@root/shared/ui-kit/info-message/info-message-dt'

import type { PairModel } from '@root/entities/pair'
import type { CreatorPairsStatsModel } from '@root/features/services/creator-pairs/atoms/reatom-creator-pairs-stats'
import type { CreatorPairsTableModel } from '@root/features/services/creator-pairs/atoms/reatom-creator-pairs-table'

type TradeDevTokensProps = {
  pair: PairModel
  tableModel: CreatorPairsTableModel | undefined
  overviewModel: CreatorPairsStatsModel | undefined
}

export const TradeDevTokens: React.FC<TradeDevTokensProps> = ({
  pair,
  tableModel,
  overviewModel,
}) => {
  const [txCreator] = useAtom(pair.initTxCreator)
  const [devTokensCount] = useAtom(
    (ctx) => {
      const totalPools = ctx.spy(pair.creatorStats)?.totalPools
      if (totalPools !== undefined) {
        return totalPools - 1
      }

      if (!txCreator || !tableModel) {
        return 0
      }
      const state = ctx.spy(tableModel)
      return AsyncStateN.isSuccess(state) ? state.value.data.length : undefined
    },
    [pair.creatorStats, tableModel, txCreator],
  )

  if (devTokensCount === 0 || !txCreator) {
    return (
      <InfoMessageDt
        withBackground
        intent="empty"
        title={t('dev-tokens.no-tokens.title')}
        description={t('dev-tokens.no-tokens.description')}
      />
    )
  }

  return (
    <Root>
      <CreatorPairsTable
        creatorAddress={txCreator.address}
        network={pair.network}
        model={tableModel}
      />
      <StatsPanel>
        {/* <StatsHeader /> */}
        <DevTokenStatistics
          pair={pair}
          creatorAddress={txCreator.address}
          overviewModel={overviewModel}
        />
      </StatsPanel>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
`

const StatsPanel = styled.div`
  background-color: var(--appearance-1);
  padding-inline: 8px;
  padding-block: 8px;
  display: grid;
  grid-template-rows: minmax(0, 1fr);
`
const _StatsHeader = styled.div`
  height: 30px;
  background-color: var(--background-2);
`
